import { createFileRoute } from "@tanstack/react-router";

import { applicationListQuerySchema } from "@kansai-ai-hub/schema";

import { AdminApplicationsPage } from "@/features/admin/applications-page";
import { adminApplicationsQueryOptions } from "@/features/applications/queries";
import { STATIC_LABELS } from "@/lib/nav-registry";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/applications/")({
  staticData: { crumb: { label: STATIC_LABELS.adminApplications } },
  validateSearch: applicationListQuerySchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    await context.queryClient.ensureQueryData(adminApplicationsQueryOptions(deps));
  },
  component: AdminApplicationsPage,
});
